import { Injectable } from '@angular/core';
import { User } from '@shared/models/user';

import loggedUserMock from '@mocks/getLoggedUser.json';

import { EMPTY, Observable} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { shareReplay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import { UserRole } from '@shared/models/codebooks/user-role';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private user: User;
  private loggedUserCache: Observable<User>;

  constructor(
    private commonService: CommonService,
    private http: HttpClient) {
    this.user = loggedUserMock;
  }

  public getLoggedUser(): Observable<User> {
    if (this.commonService.useMocks) {
      return new Observable(observer => observer.next(this.user));
    }
    if (this.loggedUserCache) {
      return this.loggedUserCache;
    }

    const observable = this.http.get<User>(this.commonService.getServiceUrl('user'))
      .pipe(shareReplay());

    this.loggedUserCache = observable;

    return observable;
  }
}
